/**
 * @flow
 * Created by neo on 01.06.17.
 */

import {observable} from 'mobx';
import BackendFactory from '../../Services/BackendFactory';
import FlightAircraft from './FlightAircraft';
import FlightOffer from '../FlightOffer';

export default class Flight {
  @observable id: string;
  @observable time_start: string;
  @observable aircraft_offer: FlightAircraft;
  @observable available_seats: number;
  @observable booked_seats: number;
  @observable files: Array<any>;
  @observable confirmed: number;

  constructor(json: any) {
    if(json) {
      this.id = json.id;
      this.start_time = json.start_time;
      this.aircraft_offer = new FlightAircraft(json.aircraft_offer || {});
      this.available_seats = json.available_seats;
      this.booked_seats = json.passengers_count;
      this.files = json.files || [];
      this.confirmed = (json.status && json.status.name === 'CONFIRMED') ? 1 : 0;
    }
  }

  static async list(page?: number = 0) {
    if (!page || 0 >= page) {
      page = 1;
    }
    const backend = await BackendFactory();
    const res = await backend.get('/flight');
    if(res.ok) {
      const flights = res.data.data.map(f => new Flight(f));
      return flights;
    }
    return [];
  }

  static async find(startDate: string, endDate: string) {
    const backend = await BackendFactory();
    const res = await backend.get('/flight', { startDate, endDate });
    if(res.ok) {
      const flights = res.data.data.map(f => new Flight(f));
      return flights;
    }
    return [];
  }

  static async findNext(page?: number = 0, lang?: string, location?: array = []) {
    const backend = await BackendFactory();
    const res = await backend.get('/flight', { page, lang, location });
    if(res.ok) {
      res.data.content = res.data.data.map(f => new Flight(f));
      return res.data;
    }
    return [];
  }

  static async get(flightId: string, lang?: string) {
    const backend = await BackendFactory();
    const res = await backend.get(`/flight/${flightId}`, { lang });
    if(res.ok) {
      const flight = new Flight(res.data);
      return flight;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Flight/index.js